import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { useState, useCallback, useEffect } from 'react';

var DEFAULT = {
  data: undefined,
  error: undefined,
  loading: false,
  fetch: function fetch() {}
};
var fetchNavConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function (_ref2) {
    var accountDetails = _ref2.accountDetails,
      aosBaseUrl = _ref2.aosBaseUrl,
      adfsToken = _ref2.adfsToken,
      app = _ref2.app,
      locale = _ref2.locale;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var transactionId, headers, requestOptions, response, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            transactionId = crypto.randomUUID();
            headers = new Headers();
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', adfsToken);
            headers.append('app', app);
            headers.append('transactionId', transactionId);
            headers.append('x-account-locale', locale);
            requestOptions = {
              headers: headers,
              method: 'POST',
              credentials: 'omit',
              body: JSON.stringify({
                accountDetails: accountDetails
              })
            };
            _context.next = 12;
            return fetch("".concat(aosBaseUrl, "/account/api/configs/sideNavigationBarConfig"), requestOptions);
          case 12:
            response = _context.sent;
            if (!(response.status !== 200)) {
              _context.next = 15;
              break;
            }
            throw new Error("Failed to fetch side navigation configuration from ".concat(aosBaseUrl, " for app: ").concat(app, ". Status code: ").concat(response.status, ", error: ").concat(response.statusText, "."));
          case 15:
            _context.next = 17;
            return response.json();
          case 17:
            result = _context.sent;
            return _context.abrupt("return", result.data);
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](0);
            throw new Error(_context.t0);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 21]]);
    })();
  });
  return function fetchNavConfig(_x) {
    return _ref.apply(this, arguments);
  };
}();
var useFetchNavConfig = function useFetchNavConfig() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$skip = _ref3.skip,
    skip = _ref3$skip === void 0 ? false : _ref3$skip,
    _ref3$accountDetails = _ref3.accountDetails,
    accountDetails = _ref3$accountDetails === void 0 ? {} : _ref3$accountDetails,
    adfsToken = _ref3.adfsToken,
    app = _ref3.app,
    aosBaseUrl = _ref3.aosBaseUrl,
    locale = _ref3.locale,
    onLoadingEnd = _ref3.onLoadingEnd;
  if (!adfsToken) {
    throw new Error('ADFS token is required to call AccountOS for side navigation bar configuration.');
  }
  if (!aosBaseUrl) {
    throw new Error('AccountOS navigation configuration url is missing.');
  }
  if (!app) {
    throw new Error('app is required to track who is calling AccountOS configuration endpoint.');
  }
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setIsLoading = _useState6[1];
  var shouldSkip = skip || loading || !!data || !!error;
  var fetch = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var navConfig, sortedNavConfig;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          setIsLoading(true);
          _context2.next = 4;
          return fetchNavConfig({
            accountDetails: accountDetails,
            adfsToken: adfsToken,
            app: app,
            aosBaseUrl: aosBaseUrl,
            locale: locale
          });
        case 4:
          navConfig = _context2.sent;
          sortedNavConfig = navConfig === null || navConfig === void 0 ? void 0 : navConfig.sort(function (a, b) {
            if ((a === null || a === void 0 ? void 0 : a.index) < (b === null || b === void 0 ? void 0 : b.index)) {
              return -1;
            }
            if ((a === null || a === void 0 ? void 0 : a.index) > (b === null || b === void 0 ? void 0 : b.index)) {
              return 1;
            }
            return 0;
          });
          setData(sortedNavConfig);
          _context2.next = 12;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          setError(_context2.t0);
        case 12:
          _context2.prev = 12;
          setIsLoading(false);
          onLoadingEnd();
          return _context2.finish(12);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9, 12, 16]]);
  })), []);
  useEffect(function () {
    if (shouldSkip) {
      return;
    }
    fetch();
  }, [fetch, shouldSkip]);
  return {
    data: data,
    error: error,
    loading: loading,
    setIsLoading: setIsLoading
  };
};

export { DEFAULT, useFetchNavConfig as default };
